import { actionCreator,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  createSearchUrlForCustomAPI,
  createSearchUrlWithoutPageNumberAndSize,
  downloadFilesOnAPICallForCCDA,
  downloaduploadedDocumentsOnAPICall,
  extractDataFromObject,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  PreviewUploadedDocumentsOnAPICall,
} from './../../../actions/utilAction';
import { API_URL } from '../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  createSearchUrlWithoutPageNumberAndSize,
  createSearchUrlForCustomAPI,
  create_post_data,
  showErrorMessage,
  showSuccessMessage,
  extractDataFromObject,
  API_URL,
  downloadFilesOnAPICallForCCDA,
  downloaduploadedDocumentsOnAPICall,
  PreviewUploadedDocumentsOnAPICall,
};

export const GET_APPCONFIG = `${API_URL}/app-configuration`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_PATIENT_BY_TAG = `${API_URL}/patient/getpatientbytag`;
export const GET_MASTER_STATE_BY_COUNTRYID = `${API_URL}/api/MasterData/GetStateByCountryID`;
export const GET_ALL_TAG = `${API_URL}/patient-tags`;
export const GET_PATIENT = `${API_URL}/patient`;
export const GET_PATIENTDETAILS_API = `${API_URL}/Patients/GetPatientById`;
export const POST_PATIENTDETAILS_API = `${API_URL}/Patients/CreateUpdatePatient`;
export const GET_PATIENT_PROFILE_DETAILS = `${API_URL}/patients/GetPatientsDetails`;
export const FILTER_PATIENT = `${API_URL}/patient/GetAsync`;
export const GET_FILTER_PATIENT_API = `${API_URL}/Patients/GetPatients`;
export const GET_PATIENT_PREFEFENCES = `${API_URL}/patient-preference`;
export const FAMILY_MEDICAL_HISTORY = `${API_URL}/patient-medical-family-history`;
export const POST_PATIENT_SOCIAL_HISTORY_API = `${API_URL}/PatientsSocialHistory/SavePatientSocialHistory`;
export const GET_PATIENT_SOCIAL_HISTORY_API = `${API_URL}/PatientsSocialHistory/GetPatientSocialHistory`;
// export const POST_PATIENT_ILLNESS = `${API_URL}/patient-past-illness`;
// export const GET_PATIENT_ILLNESS = `${API_URL}/patient-past-illness`;
// export const DELETE_PATIENT_ILLNESS = `${API_URL}/patient-past-illness`;
export const DELETE_PATIENT_ADDRESS = `${API_URL}/patien/t-address`;
export const GET_PATIENT_DIAGNOSIS_API = `${API_URL}/PatientsDiagnosis/GetDiagnosis`;
export const GET_PATIENT_DIAGNOSIS_DETAIL_API = `${API_URL}/PatientsDiagnosis/GetDiagnosisById`;
export const POST_PATIENT_DIAGNOSIS_API = `${API_URL}/PatientsDiagnosis/SavePatientDiagnosis`;
export const DELETE_DIAGNOSIS_API = `${API_URL}/PatientsDiagnosis/DeleteDiagnosis`;
export const GET_PATIENT_IMMUNIZATION_API = `${API_URL}/PatientsImmunization/GetImmunization`;
export const GET_PATIENT_IMMUNIZATION_BYID_API = `${API_URL}/PatientsImmunization/GetImmunizationById`;
export const POST_PATIENT_IMMUNIZATION_API = `${API_URL}/PatientsImmunization/SavePatientImmunization`;
export const DELETE_PATIENT_IMMUNIZATION_API = `${API_URL}/PatientsImmunization/DeleteImmunization`;

// custom api's for patient vitals ...
export const GET_PATIENT_VITALS_LIST = `${API_URL}/PatientsVitals/GetVitals`;
export const POST_PATIENT_VITAL = `${API_URL}/PatientsVitals/SaveVital`;
export const GET_PATIENT_VITAL_DETAILS = `${API_URL}/PatientsVitals/GetVitalById`;
export const DELETE_PATIENT_VITAL = `${API_URL}/PatientsVitals/DeleteVital`;

export const PATIENT_ADDRESS_API = `${API_URL}/patient-address`;
export const POST_PATIENT_ADDRESS_PHONE_DETAILS_API = `${API_URL}/PatientsAddress/SavePhoneAddress`;
export const GET_PATIENT_ADDRESS_PHONE_DETAILS_API = `${API_URL}/PatientsAddress/GetPatientPhoneAddress`;
export const PATIENT_PHONE_API = `${API_URL}/patient-phone-number`;
export const PATIENT_PHONE_API_POST_MULTIPLE = `${API_URL}/patient-phone-number/postMultiple`;
export const PATIENT_TAG = `${API_URL}/patient-tags/postMultiple`;
export const PATIENT_INSURANCE_API = `${API_URL}/patient-insurance-detail`;
export const POST_PATIENT_INSURANCE_API = `${API_URL}/PatientsInsurance/SavePatientInsurance`;
export const GET_PATIENT_INSURANCE_API = `${API_URL}/PatientsInsurance/GetPatientInsurances`;
export const PATIENT_PAYERS_API = `${API_URL}/GetPayerByPatient`;
export const PATIENT_PAYERS_FOR_AUTHORIZATION_API = `${API_URL}/GetPayerByPatientForAuthorization`;
export const PATIENT_MEDICATION_API = `${API_URL}/patient-medication`;

// custom api's for patient medications ...
export const GET_PATIENT_MEDICATION_LIST = `${API_URL}/PatientsMedication/GetMedication`;
export const POST_PATIENT_MEDICATION = `${API_URL}/PatientsMedication/SaveMedication`;
export const GET_PATIENT_MEDICATION_DETAIL = `${API_URL}/PatientsMedication/GetMedicationById`;
export const DELETE_PATIENT_MEDICATION_DETAIL = `${API_URL}/PatientsMedication/DeleteMedication`;


export const PATIENT_INSURED_PERSON_API = `${API_URL}/insured-person`;
export const PATIENT_LAB_ORDER = `${API_URL}/patient-lab-test`;
export const PARENT_GUARDIAN_API = `${API_URL}/patient-guardian`;
// custom api's for patient guardian ...
export const GET_GUARDIAN_LIST_API = `${API_URL}/PatientsGuardian/GetPatientGuardian`;
export const GET_GUARDIAN_DETAILS_API = `${API_URL}/PatientsGuardian/GetPatientGuardianById`;
export const POST_GUARDIAN_DETAILS_API = `${API_URL}/PatientsGuardian/CreateUpdatePatientGuardian`;
export const DELETE_GUARDIAN_DETAILS_API = `${API_URL}/PatientsGuardian/DeletePatientGuardian`;
export const PATIENT_CUSTOM_API = `${API_URL}/patient-custom-labels`;
// export const PATIENT_ALLERGIES = `${API_URL}/patient-allergy`;
// custom api's for patient allergies ...
export const GET_PATIENT_ALLERGIES_LIST = `${API_URL}/PatientsAllergy/GetAllergies`;
export const POST_PATIENT_ALLERGY = `${API_URL}/PatientsAllergy/SaveAllergy`;
export const GET_PATIENT_ALLERGY_DETAILS = `${API_URL}/PatientsAllergy/GetAllergyById`;
export const DELETE_PATIENT_ALLERGY = `${API_URL}/PatientsAllergy/DeleteAllergy`;

export const PATIENT_ENCOUNTERS = `${API_URL}/patient-encounter/GetPatientEncounter`;
export const PATIENT_ENCOUNTERS_DETAILS = `${API_URL}/patient-encounter/GetPatientEncounterDetails`;
export const POST_PATIENT_ENCOUNTERS_GENERATE_NARRATIVE_SUMMARY = `${API_URL}/patient-encounter/GenerateNarrativeSummary`;
// export const PATIENT_AUTHORIZATION = `${API_URL}/authorization`;
// export const PATIENT_AUTHORIZATION_PROCEDURES = `${API_URL}/authorization-procedures/patchMultiple`;

// custom api's for patient authorizations ...
export const GET_PATIENT_AUTHORIZATION_LIST = `${API_URL}/Authorizations/GetAllAuthorizationsForPatient`;
export const GET_PATIENT_AUTHORIZATION_DETAILS = `${API_URL}/Authorizations/GetAuthorizationById`;
export const POST_PATIENT_AUTHORIZATION = `${API_URL}/Authorizations/SaveAuthorization`;
export const DELETE_PATIENT_AUTHORIZATION = `${API_URL}/Authorizations/DeleteAutorization`;
export const UPDATE_AUTHORIZATION_ACTIVE_STATUS = `${API_URL}/Authorizations/UpdateRemoveAutorizationFromDashboard`;

export const FAVOURITE_API = `${API_URL}/user-favourite`;

export const NON_BILLABLE_ENCOUNTER_API = `${API_URL}/patient-encounter/GetPatientNonBillableEncounterDetails`;
export const SOAP_API = `${API_URL}/patient-encounter/GetPatientEncounterDetails`;
export const SAVE_SOAP_API = `${API_URL}/patient-encounter/SavePatientEncounter`;
export const PAYER_CPT_CODE_API = `${API_URL}/payer-service-codes`;
export const PAYER_INFO = `${API_URL}/payer-information`;
export const PAYER_ACTIVITY = `${API_URL}/payer-appointment-types`;
export const GET_ICD_API = `${API_URL}/master-i-c-d`;
export const GET_CPT_API = `${API_URL}/master-service-code`;
export const Claim_API = `${API_URL}/Claim/CreateClaim`;
export const GET_MASTERCUSTOMLABELS = `${API_URL}/master-custom-label`;
export const GET_CUSTOMLABELS_API = `${API_URL}/PatientsCustomLabel/GetPatientCustomLabels`;
export const POST_CUSTOMLABELS_API = `${API_URL}/PatientsCustomLabel/SavePatientCustomLabels`;
export const PATIENTPORTAL_ACTIVATION = `${API_URL}/patients/UpdatePatientPortalVisibility`;
export const PATIENT_STATUS_ACTIVATION = `${API_URL}/patients/UpdatePatientActiveStatus`;
export const PATIENT_LOCK_ACTIVATION = `${API_URL}/patient/UpdatePatientLockStatus`;
export const CLIENT_LOCK_ACTIVATION = `${API_URL}/user/UpdateUserStatus`;
//export const GET_PAYER_SERVICE_CODES_API = `${API_URL}/patients/GetPatientPayerServiceCodes`;
export const GET_PAYER_SERVICE_CODES_API = `${API_URL}/patients/GetPatientPayerServiceCodesAndModifiers`;
export const UPLOAD_PATIENT_DOCUMENTS_API = `${API_URL}/userDocument/UploadUserDocuments`; // Upload documents main
export const IMPORT_PATIENT_CCDA = `${API_URL}/patients/ImportPatientCCDA`;
export const PATIENT_DOCUMENT_DOWNLOAD = `${API_URL}/userDocument/GetUserDocuments`; // Get document listing render
export const UPLOADED_DOCUMENT_DOWNLOAD = `${API_URL}/userDocument/GetUserDocument`; // Uploaded document download
export const DELETE_UPLOADED_DOCUMENT = `${API_URL}/userDocument/DeleteUserDocument`; // Delete Uploaded document
export const GET_PATIENTLIST = `${API_URL}/patients/GetPatientsList`;

export const POST_PATIENT_INTERNAL_NOTES_API = `${API_URL}/api/PatientInternalNotes/SavePatientInternalNote`;
export const GET_PATIENT_INTERNAL_NOTES_API = `${API_URL}/api/PatientInternalNotes/GetPatientInternalNotes`;
export const DELETE_PATIENT_INTERNAL_NOTES_API = `${API_URL}/api/PatientInternalNotes/DeletePatientInternalNote`;
export const PREVIEW_DOCUMENT_DOWNLOAD = `${API_URL}/userDocument/GetUserDocument`; //Uploaded document preview

export const GET_USERDOCUMENT_MASTERFOLDER = `${API_URL}/api/UserDocumentMasterFolder/GetUserDocumentMasterFolder`; // Get document listing render
export const POST_USERDOCUMENT_MASTERFOLDER = `${API_URL}/api/UserDocumentMasterFolder/SaveUserDocumentMasterFolder`;
export const GET_USERDOCUMENT_MASTERFOLDERBYID = `${API_URL}/api/UserDocumentMasterFolder/GetUserDocumentMasterFolderById`;
export const DETELE_USERDOCUMENT_MASTERFOLDERBYID = `${API_URL}/api/UserDocumentMasterFolder/DeleteUserDocumentMasterFolder`;

export const GET_USERDOCUMENT_SUBFOLDER = `${API_URL}/api/UserDocumentSubFolder/GetUserDocumentSubFolder`; // Get document listing render
export const POST_USERDOCUMENT_SUBFOLDER = `${API_URL}/api/UserDocumentSubFolder/SaveUserDocumentSubFolder`;
export const GET_USERDOCUMENT_SUBFOLDERBYID = `${API_URL}/api/UserDocumentSubFolder/GetUserDocumentSubFolderById`;
export const DETELE_USERDOCUMENT_SUBFOLDERBYID = `${API_URL}/api/UserDocumentSubFolder/DeleteUserDocumentSubFolder`;

export const MOVE_BATCHDOCUMENTS_INTO_FOLDER = `${API_URL}/UserDocument/MoveBatchDocumentsIntoFolder`;
export const INACTIVE_BATCHDOCUMENTS = `${API_URL}/UserDocument/InactiveBatchDocuments`;
export const DELETE_BATCHDOCUMENTS = `${API_URL}/UserDocument/DeleteBatchDocuments`;
export const ACTIVE_BATCHDOCUMENTS = `${API_URL}/UserDocument/ActiveBatchDocuments`;

export const POST_UPLOADCLIENTLIST = `${API_URL}/patients/UploadClientsList`;
export const GET_DOWNLOADSESSIONNOTESDOCUMENTS_API = `${API_URL}/patient-encounter/DownloadSessionNotesDocuments`;
export const PATIENT_STATUS_EXCLUDEFULLYPAID = `${API_URL}/patients/UpdatePatientExcludeFullyPaidStatus`;
export const GET_PATIENT_LOCATIONS_API = `${API_URL}/Patients/GetPatientLocationById`;
export const GET_AVAILABILITY_TEMPLATE = `${API_URL}/AvailabilityTemplates/GetAvailability`;
export const POST_AVAILABILITY_TEMPLATE_API = `${API_URL}/AvailabilityTemplates/SaveUpdateAvailability`;
export const GET_AVAILABILITY_TEMPLATE_WITH_LOCATION = `${API_URL}/ClientAvailabilityTemplates/GetClientAvailabilityWithLocation`;
export const POST_AVAILABILITY_TEMPLATE_WITH_LOCATION_API = `${API_URL}/ClientAvailabilityTemplates/SaveUpdateClientAvailabilityWithLocation`;

export const patientActionTypes = {
  get_appConfig: createRequestActionTypes('GET_APPCONFIG'),
  get_masterdata: createRequestActionTypes('GET_MASTERSDATA'),
  get_patient_by_tag: createRequestActionTypes('GET_PATIENT_BY_TAG'),
  get_master_state_by_countryid: createRequestActionTypes('GET_MASTER_STATE_BY_COUNTRYID'),
  get_all_tag: createRequestActionTypes('GET_ALL_TAG'),
  post_patientdata: createRequestActionTypes('SAVE_PATIENTDATA'),
  post_patientDetails: createRequestActionTypes('POST_PATIENTDETAILS'),
  get_patientDetailsById: createRequestActionTypes('GET_PATIENTDETAILS_BYID'),
  get_patientdata: createRequestActionTypes('GET_PATIENTDATA'),
  get_patientById: createRequestActionTypes('GET_PATIENTDATA_BYID'),
  get_patientAddressById: createRequestActionTypes('GET_PATIENT_ADDRESS_BYID'),
  new_patient: createRequestActionTypes('NEW_PATIENT'),
  get_patientPhoneById: createRequestActionTypes('GET_PATIENT_PHONE_BYID'),
  get_patient_ByALPHABET: createRequestActionTypes('GET_PATIENT_BYALPHABET'),
  get_patient_ByFilter: createRequestActionTypes('GET_PATIENT_BYFILTER'),
  get_patient_ByFilterWithTags: createRequestActionTypes('GET_PATIENT_BYFILTER_WITH_TAGS'),
  get_patients: createRequestActionTypes('GET_PATIENTS'),
  get_all_patients: createRequestActionTypes('GET_PATIENTS'),
  get_patients_by_location: createRequestActionTypes('GET_PATIENTS'),
  post_patient_preference: createRequestActionTypes('POST_PATIENT_PREFEFENCE'),
  get_patient_preference: createRequestActionTypes('GET_PATIENT_PREFEFENCE'),
  post_patient_address: createRequestActionTypes('POST_PATIENT_ADDRESS'),
  post_patientAddressPhoneDetails: createRequestActionTypes('POST_PATIENTADDRESSPHONEDETAILS'),
  get_patientAddressPhoneDetails: createRequestActionTypes('GET_PATIENTADDRESSPHONEDETAILS'),
  post_patient_tag: createRequestActionTypes('POST_PATIENT_TAG'),
  post_patient_phones: createRequestActionTypes('POST_PATIENT_SUCCESS'),
  get_patient_address: createRequestActionTypes('GET_PATIENT_ADDRESS'),
  get_patient_insurance: createRequestActionTypes('GET_PATIENT_INSURANCE'),
  get_patient_insurance_byid: createRequestActionTypes('GET_PATIENT_INSURANCE_BYID'),
  get_patient_payer_service_codes: createRequestActionTypes('AUTHORIZATION_GET_PATIENT_PAYER_SERVICE_CODES'),
  get_patient_encounters: createRequestActionTypes('GET_PATIENT_ENCOUNTERS'),
  get_patient_single_encounters: createRequestActionTypes('GET_PATIENT_SINGLE_ENCOUNTERS'),
  get_nonBillableEncounterDetails: createRequestActionTypes('GET_NONBILLABLEENCOUNTERDETAILS'),
  get_patient_current_insurance: createRequestActionTypes('GET_PATIENT_CURRENT_INSURANCE'),
  get_patient_current_insured_person: createRequestActionTypes('GET_PATIENT_CURRENT_INSURED_PERSON'),
  post_patient_insurance: createRequestActionTypes('POST_PATIENT_INSURANCE'),
  post_patientInsuranceDetails: createRequestActionTypes('POST_PATIENTINSURANCEDETAILS'),
  get_patientInsuranceDetails: createRequestActionTypes('GET_PATIENTINSURANCEDETAILS'),
  post_patientEncountersGenerateNarrativeSummary: createRequestActionTypes('POST_PATIENT_ENCOUNTERS_GENERATE_NARRATIVE_SUMMARY'),

  // custom action types for patient medications ...
  delete_patientMedication: createRequestActionTypes('DELETE_PATIENTMEDICATION'),
  post_patientMedication: createRequestActionTypes('POST_PATIENTMEDICATION'),
  get_patientMedicationsList: createRequestActionTypes('GET_PATIENTMEDICATIONSLIST'),
  get_patientMedicationsDetails: createRequestActionTypes('GET_PATIENTMEDICATIONSDETAILS'),


  post_patient_insured_person: createRequestActionTypes('POST_PATIENT_INSURED_PERSON'),
  list_medical_history: createRequestActionTypes('LIST_MEDICAL_HISTORY'),
  get_patientSocialHistoryByPatientId: createRequestActionTypes('GET_PATIENT_SOCIAL_HISTORY_BY_PATIENTID'),
  post_patient_social_history: createRequestActionTypes('POST_PATIENT_SOCIAL_HISTORY'),
  post_patient_illness: createRequestActionTypes('POST_PATIENT_ILLNESS'),

  // custom action types for patient vitals ...
  get_patientVitalsList: createRequestActionTypes('GET_PATIENTVITALSLIST'),
  post_patientVital: createRequestActionTypes('POST_PATIENTVITAL'),
  get_patientVitalDetails: createRequestActionTypes('GET_PATIENTVITALDETAILS'),
  delete_patientVital: createRequestActionTypes('DELETE_PATIENTVITAL'),

  get_patient_illness_action: createRequestActionTypes('GET_PATIENT_ILLNESS'),
  delete_patient_illness_action: createRequestActionTypes('DELETE_PATIENT_ILLNESS'),
  delete_patient_address_action: createRequestActionTypes('DELETE_PATIENT_ADDRESS'),
  save_family_history: createRequestActionTypes('SAVE_FAMILY_HISTORY'),
  save_primary_diagnosis: createRequestActionTypes('SAVE_PRIMARY_DIAGNOSIS'),
  delete_family_history: createRequestActionTypes('DELETE_FAMILY_HISTORY'),
  get_patientDiagnosisList: createRequestActionTypes('GET_PATIENTDIAGNOSISLIST'),
  get_patientDiagnosisDetail: createRequestActionTypes('GET_PATIENTDIAGNOSISDETAIL'),
  post_patientDiagnosis: createRequestActionTypes('POST_PATIENTDIAGNOSIS'),
  delete_diagnosis_data: createRequestActionTypes('DELETE_DIAGNOSIS_DATA'),
  get_patient_immunization_action: createRequestActionTypes('GET_PATIENT_IMMUNIZATION'),
  get_patient_immunization_byId: createRequestActionTypes('GET_PATIENT_IMMUNIZATION_BYID'),
  post_patient_immunization: createRequestActionTypes('POST_PATIENT_IMMUNIZATION'),
  get_patient_labOrder: createRequestActionTypes('GET_PATIENT_LABORDER'),
  post_patient_LabOrder: createRequestActionTypes('POST_PATIENT_LABORDER'),
  delete_patient_labOrder: createRequestActionTypes('DELETE_PATIENT_LABORDER'),
  delete_patient_immunization_action: createRequestActionTypes('DELETE_PATIENT_IMMUNIZATION'),
  get_patientGuardianList: createRequestActionTypes('GET_PATIENTGUARDIANLIST'),
  get_patientGuardianDetails: createRequestActionTypes('GET_PATIENTGUARDIANDETAILS'),
  post_patientGuardianDetails: createRequestActionTypes('POST_PATIENTGUARDIANDETAILS'),
  delete_patientGuardianDetails: createRequestActionTypes('DELETE_PATIENTGUARDIANDETAILS'),
  get_patient_guardian_action: createRequestActionTypes('GET_PATIENT_GUARDIAN'),
  post_patient_guardian_action: createRequestActionTypes('POST_PATIENT_GUARDIAN'),
  delete_patient_guardian_action: createRequestActionTypes('DELETE_PATIENT_GUARDIAN'),
  get_patient_custom: createRequestActionTypes('GET_PATIENT_CUSTOM'),
  post_patient_custom: createRequestActionTypes('POST_PATIENT_CUSTOM'),
  // custom action types for patient allergies ...
  get_patientAllergiesList: createRequestActionTypes('GET_PATIENTALLERGIESLIST'),
  get_patientAllergyDetails: createRequestActionTypes('GET_PATIENTALLERGYDETAILS'),
  post_patientAllergy: createRequestActionTypes('POST_PATIENTALLERGY'),
  delete_patientAllergy: createRequestActionTypes('DELETE_PATIENTALLERGY'),

  get_patientAuthorizationList: createRequestActionTypes('GET_PATIENTAUTHORIZATIONLIST'),
  get_patientAuthorizationDetails: createRequestActionTypes('GET_PATIENTAUTHORIZATIONDETAILS'),
  post_patientAuthorization: createRequestActionTypes('POST_PATIENTAUTHORIZATION'),
  delete_patientAuthorization: createRequestActionTypes('DELETE_PATIENTAUTHORIZATION'),
  update_patientAuthorization_activeStatus: createRequestActionTypes('UPDATE_AUTHORIZATION_ACTIVE_STATUS'),

  post_favourite_action: createRequestActionTypes('POST_FAVOURITE'),
  get_favourite_action: createRequestActionTypes('GET_FAVOURITE'),
  post_patient_soap: createRequestActionTypes('POST_SOAP'),
  get_patient_soap: createRequestActionTypes('GET_SOAP'),
  get_CPT_byName: createRequestActionTypes('GET_CPT_BYNAME'),
  get_ICD_byName: createRequestActionTypes('GET_ICD_BYNAME'),
  create_claim: createRequestActionTypes('CREATE_CLAIM_BYENCOUNTERID'),
  get_master_tags: createRequestActionTypes('GET_MASTERTAGS'),
  get_master_custom_labels: createRequestActionTypes('GET_MASTER_CUSTOM_LABELS'),
  get_masterCustomLabels: createRequestActionTypes('GET_MASTERCUSTOMLABELS'),
  post_customLabelsValues: createRequestActionTypes('POST_CUSTOMLABELSVALUES'),
  get_payer_activities: createRequestActionTypes('GET_PAYER_ACTIVITES'),
  patient_menu_show_status: createRequestActionTypes('PATIENT_MENU_SHOW_STATUS'),
  patch_patientportal_activation: createRequestActionTypes('PATCH_PATIENTPORTAL_ACTIVATION'),
  patch_patient_active_status: createRequestActionTypes('PATCH_PATIENT_ACTIVE_STATUS'),
  patch_client_lock_status: createRequestActionTypes('PATCH_CLIENT_LOCK_STATUS'),
  get_patient_masterdata: createRequestActionTypes('GET_PATIENT_MASTERDATA'),
  get_patient_profileDetails: createRequestActionTypes('GET_PATIENT_PROFILEDETAILS'),
  upload_patient_documents: createRequestActionTypes('UPLOAD_PATIENT_DOCUMENTS'),
  get_patient_master_tags: createRequestActionTypes('GET_PATIENT_MASTER_TAGS'),
  import_patient_ccda: createRequestActionTypes('IMPORT_PATIENT_CCDA_FROM_XML'),
  get_patient_document_download: createRequestActionTypes('GET_PATIENT_DOCUMENT_DOWNLOAD'), // Patient document Listing preview
  uploaded_document_download: createRequestActionTypes('GET_UPLOADED_DOCUMENT_DOWNLOAD'), // Uploaded document download
  delete_Uploaded_Document: createRequestActionTypes('DELETE_UPLOADED_DOCUMENT'), // Delete uploaded document
  get_PatientsList: createRequestActionTypes('GET_PATIENTLIST'),

  Post_Patient_Internal_Notes: createRequestActionTypes('POST_PATIENT_INTERNAL_NOTES'),  
  Get_Patient_Internal_Notes: createRequestActionTypes('GET_PATIENT_INTERNAL_NOTES'),
  Delete_Patient_Internal_Notes: createRequestActionTypes('DELETE_PATIENT_INTERNAL_NOTES'),
  preview_document_download: createRequestActionTypes('GET_PREVIEW_DOCUMENT_DOWNLOAD'), // Uploaded document preview

  Get_UserDocumentMasterFolder: createRequestActionTypes('GET_USERDOCUMENT_MASTERFOLDER'),
  Post_UserDocumentMasterFolder: createRequestActionTypes('POST_USERDOCUMENT_MASTERFOLDER'),
  Get_UserDocumentMasterFolderById: createRequestActionTypes('GET_USERDOCUMENT_MASTERFOLDERBYID'),
  Delete_UserDocumentMasterFolderById: createRequestActionTypes('DELETE_USERDOCUMENT_MASTERFOLDERBYID'),

  Get_UserDocumentSubFolder: createRequestActionTypes('GET_USERDOCUMENT_SUBFOLDER'),
  Post_UserDocumentSubFolder: createRequestActionTypes('POST_USERDOCUMENT_SUBFOLDER'),
  Get_UserDocumentSubFolderById: createRequestActionTypes('GET_USERDOCUMENT_SUBFOLDERBYID'),
  Delete_UserDocumentSubFolderById: createRequestActionTypes('DELETE_USERDOCUMENT_SUBFOLDERBYID'),

  post_MoveBatchDocumentsIntoFolder: createRequestActionTypes('MOVE_BATCHDOCUMENTS_INTO_FOLDER'),
  post_InactiveBatchDocuments: createRequestActionTypes('INACTIVE_BATCHDOCUMENTS'),
  post_DeleteBatchDocuments: createRequestActionTypes('DELETE_BATCHDOCUMENTS'),

  post_UploadClientList: createRequestActionTypes('POST_UPLOADCLIENTLIST'),

  get_DownloadSessionNotesDocuments: createRequestActionTypes('GET_DOWNLOADSESSIONNOTESDOCUMENTS_API'),
  patch_patient_excludefullypiad_status: createRequestActionTypes('PATIENT_STATUS_EXCLUDEFULLYPAID'),
  get_patientLocations: createRequestActionTypes('PATIENT_GET_STAFFLOCATIONS'),
  get_availability_template_by_id: createRequestActionTypes('GET_AVAILABILITY_TEMPLATE_BY_ID'),
  save_availability_template: createRequestActionTypes('SAVE_AVAILIBILITY_TEMPLATE'),
  
};

export const MODULE = 'PATIENT_INFORMATION';



// WEBPACK FOOTER //
// ./src/modules/patients/constants/ApiConstants.js